import {FaCheck, FaTimes} from "react-icons/fa";
import {FaC, FaI, FaS, FaT, FaTriangleExclamation} from "react-icons/fa6";
import React, {Fragment} from "react";
import {ImageTypeEnum, OcrEnum} from "../../../utils/lanes-utils.js";
import {regionTypeTranslateObj} from "../../../utils/lanes-form-utils.js";

export const LanesListIcons = ({icon = "default", size = 14, color = ""}) => {
    if (icon === "statusTrue") return <FaCheck color={color ? color : "#31b131"} size={size}/>;
    if (icon === "statusAlert") return <FaTriangleExclamation color={color ? color : "#ffa600"} size={size}/>;
    if (icon === OcrEnum.SUPPLEMENT) return <FaC color={color ? color : "#31b131"} size={size}/>
    if (icon === OcrEnum.OVERWRITE) return <FaS color={color ? color : "#ffa600"} size={size}/>
    if (icon === ImageTypeEnum.ALL) return <FaT color={color ? color : "#31b131"} size={size}/>
    if (icon === ImageTypeEnum.DEMAND) return <FaS color={color ? color : "#ffa600"} size={size}/>
    if (icon === ImageTypeEnum.TRAFFIC) return <FaI color={color ? color : "#ffa600"} size={size}/>
    if (icon === true) return <FaCheck color={color ? color : "#31b131"} size={size}/>;

    return <FaTimes color={color ? color : "#b4b4b4"}/>;
}
export const LanesCaptions = () => {
    const captions = [
        {
            key: "Status",
            data: [
                {caption: "Ativa", icon: "statusTrue"},
                {caption: "Inativa", icon: null},
                {caption: "Alerta", icon: "statusAlert"}
            ]
        },
        {
            key: "OCR",
            data: [
                {caption: "Complementar", icon: OcrEnum.SUPPLEMENT},
                {caption: "Desligado", icon: null},
                {caption: "Sobrepor", icon: OcrEnum.OVERWRITE}
            ]
        },
        {
            key: "Imagens",
            data: [
                {caption: "Todas", icon: ImageTypeEnum.ALL},
                {caption: "Sob demanda", icon: ImageTypeEnum.DEMAND},
                {caption: "Infração", icon: ImageTypeEnum.TRAFFIC},
                {caption: "Nenhuma", icon: null}
            ]
        },
        {
            key: "Associações",
            data: [
                {caption: "Sim", icon: "statusTrue"},
                {caption: "Não", icon: null},
            ]
        }
    ];

    return (
        <div className="w-full flex items-center justify-center py-1 gap-2 flex-wrap">
            {captions.map((group) => (
                <div className="flex" key={group.key}>
                    {group.data.map((item, idx) => (
                        <div
                            key={idx}
                            className={[
                                "flex items-center gap-1 bg-white p-1 border border-[#ddd] text-[11px]",
                                idx !== 0 && "border-l-0"
                            ].join(" ")}
                        >
                            {idx === 0 && (
                                <span className="font-bold">{group.key}:</span>
                            )}

                            <LanesListIcons icon={item.icon} size={10}/>

                            <span className="italic">= {item.caption}</span>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};